import { render, staticRenderFns } from "./PointFilterHistoryLayout.vue?vue&type=template&id=70d3d85c&"
import script from "./PointFilterHistoryLayout.vue?vue&type=script&lang=js&"
export * from "./PointFilterHistoryLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports